import { TLink } from "@/components/molecules/Button";
import { faRightLong } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);

// const articles = [
//   {
//     href: "/news/article",
//     date: "2020/04/11",
//     title: "弊社事務所が移転いたしました。",
//   },
//   {
//     href: "/news/article",
//     date: "2019/10/01",
//     title: "採用情報を更新しました。",
//   },
//   {
//     href: "/news/article",
//     date: "2018/04/01",
//     title:
//       "歯科医院のためのホームページ運用サービス、「TOCCA DENALWEB BASIC」をリリースしました。",
//   },
// ];

export const TopNews = (props) => {
  let articles = props.articles;
  return (
    <>
      <div className="relative mx-auto box-border flex max-w-7xl flex-col gap-4 px-6 text-txt-base sm:px-8 md:my-8 md:gap-6 md:px-12 lg:gap-8 xl:px-0">
        <h6 className="font-bold text-pri fluid-text-[16px,22px]">News</h6>
        <div className="divide-y divide-solid divide-bdc-base border-y border-x-0 border-solid border-bdc-base">
          {articles.map((articles) => (
            <div
              key={articles.id}
              className="flex flex-col border-x-0 pt-3 md:flex-row md:items-center md:gap-5 md:pt-0"
            >
              <p className=" text-txt-light fluid-text-[11px,14px] md:text-base">
                {dayjs.utc(articles.date).tz("Asia/Tokyo").format("YYYY/MM/DD")}
              </p>
              {(() => {
                if (articles.detailflg === true) {
                  return (
                    <TLink
                      href={"/news/article/" + articles.id}
                      variant="light"
                      color="f"
                      className="group w-full pt-2 pb-5 fluid-text-[14px,18px] md:py-8"
                    >
                      {articles.title}
                      <i className="ml-2 text-icn group-hover:text-hov md:m-4">
                        <FontAwesomeIcon icon={faRightLong} />
                      </i>
                    </TLink>
                  );
                } else if (articles.url) {
                  return (
                    <TLink
                      href={articles.url ? articles.url : ""}
                      variant="light"
                      color="f"
                      className="group w-full pt-2 pb-5 fluid-text-[14px,18px] md:py-8"
                    >
                      {articles.title}
                      <i className="ml-2 text-icn group-hover:text-hov md:m-4">
                        <FontAwesomeIcon icon={faRightLong} />
                      </i>
                    </TLink>
                  );
                } else {
                  return (
                    <p className="w-full pt-2 pb-5 fluid-text-[14px,18px] md:py-8">
                      {articles.title}
                    </p>
                  );
                }
              })()}
            </div>
          ))}
        </div>
        <TLink
          href="/news"
          variant="light"
          color="f"
          className="flex w-full justify-end fluid-text-[14px,18px]"
        >
          more Information
          <i className="ml-2 text-icn group-hover:text-hov">
            <FontAwesomeIcon icon={faRightLong} />
          </i>
        </TLink>
      </div>
    </>
  );
};
